import type { CSSProperties } from 'react'
import StatusBadge from '../../components/ui/StatusBadge'
import MapMini from '../../components/ui/MapMini'
import DashIcon from '../../components/ui/DashIcon'

const zones = [
  ['Tunis Centre', 'Standard',   '5.000 DT', '142 livreurs', 'active'],
  ['La Marsa',     'Premium',    '8.000 DT', '38 livreurs',  'active'],
  ['Sfax',         'Standard',   '6.000 DT', '64 livreurs',  'active'],
  ['Sousse',       'Standard',   '5.500 DT', '58 livreurs',  'active'],
  ['Nabeul',       'Standard',   '6.500 DT', '38 livreurs',  'active'],
  ['Bizerte',      'Standard',   '7.000 DT', '32 livreurs',  'active'],
  ['Djerba',       'Express',    '12.000 DT','18 livreurs',  'active'],
  ['Tataouine',    'Long-route', '18.000 DT','8 livreurs',   'suspended'],
]

const pricingRules = [
  ['Express 1h',   '< 1h ETA',        '12.000 DT', '15%', '+2.000 DT', 'active'],
  ['Standard',     '< 4h ETA',        '5.000 DT',  '12%', '—',         'active'],
  ['Économique',   '< 24h',           '3.500 DT',  '10%', '—',         'active'],
  ['Inter-villes', 'Tunis ↔ Sfax/etc','8.000 DT',  '15%', '+1.500 DT', 'active'],
  ['Volumineux',   '> 10kg',          '+50% base', '—',   '+30% base', 'active'],
  ['Nuit (22h-6h)','Hors heures',     '+30%',      '—',   '+2.000 DT', 'active'],
]

export default function AdminZones() {
  return (
    <>
      <div className="page-head">
        <div className="ph-titles">
          <h1>Zones & Pricing</h1>
          <p>Gérez les zones de livraison, tarifs et règles d'auto-assignation.</p>
        </div>
        <div className="ph-actions">
          <button className="btn btn-primary"><DashIcon name="plus" size={14} /> Nouvelle zone</button>
        </div>
      </div>

      <div className="detail-grid" style={{ '--detail-cols': '1fr 380px', gap: 18, marginBottom: 18 } as CSSProperties}>
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--line)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3>Couverture nationale</h3>
            <span className="badge badge-green">12 zones actives</span>
          </div>
          <MapMini couriers={20} height={480} />
        </div>

        <div className="card">
          <div className="card-head">
            <h3>Zones</h3>
            <span style={{ fontSize: '.78rem', color: 'var(--muted)' }}>12 actives</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {zones.map((z, i) => (
              <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr auto auto', gap: 10, padding: 10, borderRadius: 10, border: '1px solid var(--line)', alignItems: 'center' }}>
                <div>
                  <b style={{ color: 'var(--navy-900)', fontSize: '.88rem' }}>{z[0]}</b>
                  <div style={{ color: 'var(--muted)', fontSize: '.74rem' }}>{z[3]} · Tarif {z[1]}</div>
                </div>
                <span className="mono row-strong" style={{ fontSize: '.86rem' }}>{z[2]}</span>
                <StatusBadge status={z[4]} />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-head">
          <h3>Grille tarifaire</h3>
          <button className="btn btn-sm btn-ghost">+ Ajouter règle</button>
        </div>
        <div className="tbl-scroll">
          <table className="tbl">
            <thead>
              <tr>
                <th>Règle</th><th>Condition</th><th>Tarif de base</th>
                <th>Frais Door Deal</th><th>Bonus livreur</th><th>Statut</th>
                <th className="col-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              {pricingRules.map((r, i) => (
                <tr key={i}>
                  <td className="row-strong">{r[0]}</td>
                  <td style={{ color: 'var(--muted)' }}>{r[1]}</td>
                  <td className="mono">{r[2]}</td>
                  <td className="mono">{r[3]}</td>
                  <td className="mono" style={{ color: 'var(--green-700)' }}>{r[4]}</td>
                  <td><StatusBadge status={r[5]} /></td>
                  <td className="col-actions"><button>Éditer</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
